<div class="modal fade arquivo-upload-modal" aria-hidden="true"  #modal>
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{title}}
                </h4>
                <h6 class="modal-subtitle" *ngIf="subtitle">
                    {{subtitle}}
                </h6>
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <ng-template [ngIf]="uploader">
                        <div class="arquivo-drag-drop-area"
                            [class.arquivo-drag-over]="hasBaseDropZoneOver"
                            ng2FileDrop
                            [uploader]="uploader"
                            (fileOver)="onFileOver($event)">

                            <div class="arquivo-drag-drop-area-icon">
                                <i class="fas fa-upload"></i>
                            </div>

                            <h6 class="arquivo-drag-drop-area-title">
                                Arraste arquivos aqui para adicionar <br/> ou
                            </h6>

                            <span class="btn btn-primary btn-file">
                                <i class="fas fa-paperclip"></i> Selecione os Arquivos
                                <input type="file" id="file" #inputFile ng2FileSelect [uploader]="uploader" multiple [disabled]="uploader.isUploading">
                            </span>
                        </div>
                    </ng-template>

                    <div class="arquivo-info">
                        <p class="form-text text-muted" *ngIf="uploads?.length > 0">
                            {{uploads.length}} arquivo(s) adicionado(s)
                        </p>
                        <p class="form-text text-muted" *ngIf="!uploads || uploads.length == 0">
                            Nenhum arquivo adicionado!
                        </p>
                    </div>

                    <ng-template [ngIf]="uploads && uploads.length > 0">
                        <ul class="list-group list-group-arquivos">
                            <li class="list-group-item list-group-item-arquivo" *ngFor="let upload of uploads; let index = index">
                                <span class="list-group-item-arquivo-extensao">
                                    <i [class]="upload.extensao | arquivoExtensaoIcon" aria-hidden="true"></i>
                                </span>
                                <span class="list-group-item-arquivo-body">
                                    <p class="list-group-item-arquivo-nome">
                                        {{upload.nome}}
                                        <small class="list-group-item-arquivo-size text-muted">
                                            {{upload.sizeBytes / (1024 * 1024) | decimalFormat: 1:2:2}} MB
                                        </small>
                                    </p>

                                    <span class="list-group-item-arquivo-form">
                                        <span class="list-group-item-arquivo-tipo">
                                            <label class="col-form-label">Tipo</label>
                                            <sgt-tipo-arquivo-form-select
                                                [(ngModel)]="upload.idTipoArquivo"
                                                [(tipoArquivo)]="upload.tipoArquivo"
                                                #arquivoUploadTipoArquivo="ngModel"
                                                #tipoArquivoFormSelect
                                                name="arquivoUploadTipoArquivo_{{index}}"
                                                id="arquivoUploadTipoArquivo_{{index}}"
                                                [somenteAtivos]="true"
                                                [referenciasFilter]="referencia ? [referencia.id] : null">
                                            </sgt-tipo-arquivo-form-select>
                                        </span>
                                        <span class="list-group-item-arquivo-descricao">
                                            <label for="arquivoUploadDescricao_{{index}}" class="col-form-label">Descrição</label>
                                            <textarea class="form-control" [(ngModel)]="upload.descricao" name="arquivoUploadDescricao_{{index}}" id="arquivoUploadDescricao_{{index}}"
                                                #arquivoUploadDescricao="ngModel" rows="1" sgtAutosize placeholder="Descrição sobre este arquivo...">
                                            </textarea>
                                        </span>
                                    </span>
                                </span>
                                <span class="list-group-item-arquivo-trash">
                                    <button type="button" class="btn btn-link btn-link-delete" (click)="delete(index)" title="Remover {{upload.nome}}" tabindex="-1">
                                        <i class="far fa-trash-alt"></i>
                                    </button>
                                </span>
                            </li>
                        </ul>
                    </ng-template>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="close()">
                    <i class="fas fa-times"></i> Cancelar
                </button>

                <button type="button" class="btn btn-primary" id="btnArquivoBulkUpload" (click)="bulkUpload()" *ngIf="autoUpload">
                    <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Arquivos
                </button>
                <button type="button" class="btn btn-primary" (click)="add()" *ngIf="!autoUpload">
                    <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Arquivos
                </button>
            </div>
        </div>
    </div>
</div>
